<div class="policy" [class.policy--forbidden-keywords]="titleKey" *ngIf="policy">

    <h1 class="policy__title">{{ titleKey ? (titleKey | translate) : policy.title }}</h1>

    <div class="policy__divider"></div>

    <!-- PDF Viewer (PDF.js render — white pages, no toolbar) -->
    <ng-container *ngIf="isPdf; else nonPdfContent">
        <app-pdf-viewer [pdfUrl]="pdfUrl" />
    </ng-container>

    <ng-template #nonPdfContent>
        <div class="policy__keywords-wrap" *ngIf="titleKey; else htmlContent">
            <table class="policy__keywords-table">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">{{ 'FOOTER.KEYWORD' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let keyword of forbiddenKeywords; let i = index">
                        <td class="policy__keywords-index">{{ i + 1 | number:'2.0-0' }}</td>
                        <td class="policy__keywords-term">{{ keyword }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <ng-template #htmlContent>
            <div class="policy__content" [innerHTML]="safeContent"></div>
        </ng-template>
    </ng-template>

</div>